if(!customElements.get('custom-option')) {
  customElements.define('custom-option', class CustomOption extends HTMLElement {
    constructor() {
      super();
      this.position = this.dataset.position || null;
      this.setQty = this.dataset.qty || null;
      this.name = this.dataset.name || null;
    }

    connectedCallback() {
      if (window.productOptions) {
          this.innerHTML = `
            <div class="selectbox">
              <table class="spec" width="100%" border="0" cellspacing="0" cellpadding="0">
                <tbody>
                ${ this.setQty > 1 ? `<tr class="option_area">
                  <th class="ttl" colspan="2">${this.name}</th>
                </tr>` : ''}
                ${this.setQty > 1 ? `<input type="hidden" class="hkitemcd" name="properties[${this.setQty > 1 ? (this.position == "Left" ? "左" : "右") + ' - HKItemCD' : 'HKItemCD'}]" value="">` : ''}
                ${this.setQty > 1 ? `<input type="hidden" name="properties[${this.position == 'Right' ? '【右目】' : '【左目】'}]" value="${this.setQty / 2}箱">` : ''}
                ${window.productOptions.filter(op => op.values.length > 0).map((option, idx) => 
                    `<tr class="option_area">
                      <th>${option.name}:</th>
                      <td>
                        <select class="option_parts" data-name="${option.name.toLowerCase()}" name="properties[${this.setQty > 1 ? (this.position == "Left" ? "左" : "右") + ' - ' + option.name :  option.name}]" id="sel${this.position}Eye${option.name}" required>
                          <option value="">選択してください</option>
                          ${this.customSort(option).map((value, jdx) => `<option value="${value}">${value}</option>` ).join('')}
                        </select>
                      </td>
                    </tr>`
                  ).join('')}
                  <tr>
                    <th>数量:</th>
                    <td>
                    ${this.setQty > 1 ? this.setQty / 2 + '箱' : ''}
                        <input type="${this.setQty == 1 ? 'number': 'hidden'}" name="quantity" value="1">
                        ${this.setQty == 1 ? '箱': ''}
                    </td>
                </tr>
                </tbody>
              </table>
            </div>
          `;
          this.selects = this.querySelectorAll('select');
          this.selects.forEach((select) => {
            select.addEventListener('change', this.onSelectChange.bind(this));
          });
      }
    }

    async isFiledAll(){
      var fieldIsValid = '';
      const validCustomOptions = Array.from(document.querySelectorAll('custom-option')).every(co => {
          return Array.from(co.selects).every(select => {
            fieldIsValid = select.dataset.name.toUpperCase();
              return select.value;
          });
      });
      if(!validCustomOptions){
          return;
      }else{
        await this.fetchCalculateShippingDays();
      }
    }

    customSort(option) {
      let arr = option.values;
      if(option.name.toLowerCase() == "bc/dia"){
        return arr;
      }
      if(arr.length == 1){
        return arr
      }
      const negatives = arr
        .filter(n => n < 0)
        .sort((a, b) => Math.abs(a) - Math.abs(b));

      const nonNegatives = arr
        .filter(n => n >= 0)
        .sort((a, b) => a - b);

      return [...negatives, ...nonNegatives];
    }

    async fetchCalculateShippingDays(){
      const lineItems = [
        {
          id: 1,
          quantity: document.querySelector('[name="options[Set]"]').value != '1' ? document.querySelector('[name="options[Set]"]').value : document.querySelector('form[data-type="add-to-cart-form"] [name="quantity"]').value,
          product: {
            itemCode: {
              value: window.productItemCD
            }
          },
          variant: {
            title: document.querySelector('[name="options[Set]"]').value
          },
          outlet: false,
          customAttributes: Array.from(document.querySelectorAll('.option_parts')).map(part => {
            return {
              key: part.getAttribute('name').replace('properties[','').replace(']',''),
              value: part.value
            }
          }).concat([
            {
              "value": window.productItemCD,
              "key": "商品番号"
            },
          ])
        }
      ]
        const payload = {
          "shopCD": "31",
          "lineItems": lineItems
        };
        try{
          const res = await fetch('https://api.lens-labo.com/Api/Shopify/v1/CalculateShippingDays',{
            method: 'post',
            headers: {
              'Content-Type': 'application/json; charset=UTF-8',
            },
            body: JSON.stringify(payload)
          }).then(res => res.json())
          if(res.length > 0){
            document.querySelector('.ai-delivery-info-text').innerText = res[0].shippingDaysEstimated;
            if(res[0].shippingDaysEstimated == "受注不可"){
              document.querySelector('.product-form__submit').setAttribute('disabled',true);
            }else{
              document.querySelector('.product-form__submit').removeAttribute('disabled');
            }
          }
        }catch(error){
          console.log(error)
        }
      }

    onSelectChange() {
        const optionValues = Array.from(this.selects).map(select => ({
            name: select.dataset.name,
            value: select.value
        }));
        const matchedVariant = window.productVariants.find(variant => {
            return optionValues.every(option => {
                var variantValue = variant[option.name];
                if(option.name == "bc/dia"){
                    variantValue = variant.bc + '/' + variant.dia;
                }else if(option.name == "pwr"){
                    variantValue = variant.pwr.toFixed(2);
                }
                return variantValue != null && variantValue.toString() === option.value;
            });
        });
        if(matchedVariant){
            const variantIdInput = document.querySelector('.product-variant-id');
            variantIdInput.value = matchedVariant.id;
            variantIdInput.dispatchEvent(new Event('change'));
        }
        this.isFiledAll()
    }

    getOptionIndex() {
      const allOptions = document.querySelectorAll('custom-option');
      return Array.from(allOptions).indexOf(this);
    }
  });
}